<template>
  <b-modal
    id="delete-modal"
    ref="deleteMessageModal"
    modal-class="delete-modal"
    size="sm">
    <div class="text-center">
      <h5>Are you sure you want to delete this message?</h5>
    </div>
    <template slot="modal-footer">
      <b-button @click="hide">
        Close
      </b-button>
      <b-button
        :disabled="deleting"
        @click="commitDelete">
        Yes
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DeleteMessageModal',
  data() {
    return {
      replyId: false,
      messageId: false,
      deleting: false,
    };
  },
  computed: {
    ...mapGetters({
      messageDeleted: 'automation/instantReplyMessageDeleted',
      apiError: 'automation/apiError',
    }),
  },
  watch: {
    messageDeleted(deleted) {
      if (deleted) {
        this.deleting = false;
        this.$emit('deleted', deleted);
        this.$refs.deleteMessageModal.hide();
      }
    },
  },
  methods: {
    ...mapActions({
      deleteMessage: 'automation/deleteInstantReplyMessage',
    }),
    messageToDelete(replyId, messageId) {
      this.replyId = replyId;
      this.messageId = messageId;
    },
    commitDelete() {
      this.deleting = true;
      if (!this.isTemp(this.replyId)) {
        this.deleteMessage({
          merchant_id: this.$route.params.merchant_id,
          reply_id: this.replyId,
          message_id: this.messageId,
        });
      } else {
        this.deleting = false;
        this.$emit('deleted', this.messageId);
        this.$refs.deleteMessageModal.hide();
      }
    },
    isTemp(id) {
      return id.lastIndexOf('temp-', 0) === 0;
    },
    show() {
      this.$refs.deleteMessageModal.show();
    },
    hide() {
      this.deleting = false;
      this.$refs.deleteMessageModal.hide();
    },
  },
};
</script>
